define([
    "../nlgLGPDModule"
], function (lgpdModule) {
    "use strict";

    return lgpdModule.controller("LGPDClassifiableControllerSearch", [
        "$scope",
        "LGPDClassifiableService",
        "remoteExceptionHandler",
        "messagesModal",
        "$state",
        "nlgLGPD",
        function ($scope, classificationService, remoteExceptionHandler, messagesModal, $state, nlgLGPD) {
            var filterPatch, paginationApi;

            $scope.serviceName = nlgLGPD.getClassificationPath();

            $scope.search = function (patch) {
                filterPatch = patch;
                paginationApi.seekPage(1);
            };

            $scope.tableOptions = {
                records: [],
                pagination: {
                    onPaginate: function (firstResult, maxResults) {
                        return classificationService.filterRecords(filterPatch, firstResult, maxResults)
                            .then(function (response) {
                                var result = response.data;
                                result.result = result.result[0].lgpdDefinitions;
                                return result;
                            })
                            .catch(remoteExceptionHandler());
                    }
                },
                onRegisterPagination: function (api) {
                    paginationApi = api;
                }
            };

            $scope.delete = function (id) {
                return messagesModal.cancellable("dialog.warning", ["edition.lgpd.delete.entity"])
                    .then(function () {
                        return classificationService.deleteEntity(id).then(function () {
                            return messagesModal("dialog.success", {
                                keyBundle: "lgpd.edition.delete.success"
                            }).then(function () {
                                paginationApi.seekPage(1);
                            });
                        }).catch(remoteExceptionHandler());
                    });
            };
        }]);

});
